import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { validatePasswordsMatch } from "@repo/lib/helpers";
import { useFormValidation } from "@repo/lib/hooks/common";
import { validation } from "@repo/lib/utils";
import { resetPassword } from "@repo/server-actions/account";
import { useTranslations } from "next-intl";
import { redirect } from "next/navigation";
import { useCallback, useState, useTransition } from "react";

const useResetPassword = (token, email) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { formValues, formErrors, setFormErrors, handleValidation } =
    useFormValidation({
      password: "",
      confirm: "",
    });
  const [isPending, startTransition] = useTransition();
  const { setSnackbar } = useSnackbarContext();
  const t = useTranslations("Common");
  // Toggle the visibility of password
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const submitForm = useCallback(async () => {
    const payLoad = {
      newPassword: formValues?.password,
      confirmPassword: formValues?.confirm,
      email,
    };

    const response = await resetPassword(payLoad, token);

    (console.log("resetPassword", response),
      await setSnackbar({
        open: true,
        message: response?.message,
        type: response?.success ? "success" : "error",
      }));

    if (response?.success) redirect("/password-updated");
  }, [formValues, setSnackbar, token, email]);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      const validationErrors = validation(formValues, t);
      const passwordMatchErrors = validatePasswordsMatch(formValues, t);

      const errors = { ...validationErrors, ...passwordMatchErrors };

      if (Object.keys(errors).length === 0) {
        startTransition(() => submitForm());
      } else {
        setFormErrors(errors);
      }
    },
    [formValues, setFormErrors, submitForm, t]
  );

  return {
    formValues,
    formErrors,
    handleValidation,
    isPending,
    showPassword,
    showConfirmPassword,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
    handleSubmit,
  };
};

export default useResetPassword;
